import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@vapor/react-material";
import React, { useState, useEffect } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 2;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

interface SelectMultipleCheckboxesProps {
  options?: string[];
  width?: number | string;
  label?: string;
  handleCheckboxChange: any;
  documentType?: string; // Added documentType prop
}

const names = ["Verificare", "In scadenza", "Verificati"];

const SelectCheckboxesArray: React.FC<SelectMultipleCheckboxesProps> = ({
  options,
  width = 200,
  label = "Tag",
  handleCheckboxChange,
  documentType = "", // Default value for documentType
}: SelectMultipleCheckboxesProps) => {
  const [menuOptions, setMenuOptions] = useState<string[]>(options ?? names);
  const [selections, setSelections] = useState<string[]>([]);

  // useEffect to check if documentType is "Tutto l'anno" and set all options as selected
  useEffect(() => {
    if (documentType === "Tutto l'anno") {
      setSelections(menuOptions);
    }
  }, [documentType, menuOptions]);

  useEffect(() => {
    handleCheckboxChange(selections);
  }, [selections]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelections(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <div>
      <FormControl sx={{ width: width }}>
        <InputLabel id="demo-multiple-checkbox-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selections}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected: []) =>
            !!selected ? selected?.join(", ") : "Apri opzioni"
          }
          MenuProps={MenuProps}
          fullWidth={false}
        >
          {menuOptions.map((name) => (
            <MenuItem sx={{ p: 0, width: width }} key={name} value={name}>
              <Checkbox checked={selections.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default SelectCheckboxesArray;
